define('webshopLandingpagesListToolsView',[
  'module',
  'underscore',
  'tableFieldView',
  'modalsConfirmationView',
  'template!webshopLandingpagesListToolsView',
  'entities/webshop/landingpages'
], function (
  Module,
  _,
  FieldView,
  ConfirmationView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-landingpages-tools-view ' + FieldView.prototype.className,

    ui: {     
      deleteButton: '.delete'
    },

    events: {    
      'click @ui.deleteButton': 'onDelete'
    },

    onDelete: function () {
      ConfirmationView.prototype.open({
        text: _.i18n('landingpages.delete.confirmation'),
        onConfirm: _.bind(function() {
          this.model.remove().done(_.bind(function() {
            this.tableView.bodyView.deleteRow(this.options.rowView);
          }, this));
        },this)
      });
    }
  });
});
